import { Rating } from "@material-ui/lab";
import React from "react";
import { StarRatting } from "../../../../../../components";
import { getMovers } from "../../../../../../ui_libs/Functions/functions";

function CompanyInfo(props) {
  const { name, address, company_email, company_phone } =
    props.requestData.bid_Accepted_company;
  const { first_name, last_name } = props.requestData.get_foreman_of_company;
  console.log(props, "props truck assign");
  const { request_timeline_status, request_type } = props.requestData.request;
  const { truck_array } = props.requestData;

  return (
    <div
      className={
        request_timeline_status > 4
          ? "company-info-wrapper pt-3 border-bottom"
          : "company-info-wrapper pt-3"
      }
    >
      <p className="text-center font-weight-bold">Company Info</p>
      <div className="row small-font-size pt-2">
        <div className="col-4 text-left dark-grey-color">Company:</div>
        <div className="col-8 text-right">{name}</div>
      </div>
      <div className="row small-font-size pt-3">
        <div className="col-4 text-left dark-grey-color">Phone #:</div>
        <div className="col-8 text-right black-color">{company_phone}</div>
      </div>
      <div className="row small-font-size pt-3">
        <div className="col-4 text-left dark-grey-color">Email:</div>
        <div className="col-8 text-right black-color">
          <a href="mailto:companyname@example.com" className="light-red-color">
            {company_email}
          </a>
        </div>
      </div>
      <div className="row small-font-size pt-3">
        <div className="col-4 text-left dark-grey-color">Address:</div>
        <div className="col-8 text-right black-color">{address}</div>
      </div>
      {request_timeline_status > 3 && (
        <>
          <div className="row small-font-size pt-3">
            <div className="col-6 text-left dark-grey-color">Foreman name:</div>
            <div className="col-6 text-right">
              {first_name + " " + last_name}
            </div>
          </div>
          <div className="row small-font-size pt-3">
            <div className="col-6 text-left dark-grey-color">Truck Name:</div>
            <div className="col-6 text-right">
              {" "}
              {truck_array.map((truck, i) => {
                return truck.name + (i === truck_array.length - 1 ? "" : ", ");
              })}{" "}
            </div>
          </div>
          {/* {request_timeline_status === 8 && (
            <>
              <div className="row small-font-size pt-3">
                <div className="col-4 text-left dark-grey-color">Rating:</div>
                <div className="col-8 text-right">
                  <Rating
                    style={{ verticalAlign: "bottom" }}
                    name="read-only"
                    precision={0.1}
                    value={props.requestData.get_feedback.company_rating}
                    size="large"
                    readOnly
                  />
                </div>
              </div>
              <div className="row small-font-size pt-3">
                <div className="col-12 text-left dark-grey-color">
                  Feedback:
                </div>
                <div className="col-12">
                  {props.requestData.get_feedback.company_comment}
                </div>
              </div>
            </>
          )} */}
        </>
      )}
    </div>
  );
}

export default CompanyInfo;
